import { payOrder } from "network/application.js"
import { Message } from 'element-ui'
import router from "../router"
var bridgeData = {}
var getPayOrder = function(data,callback){
    payOrder({
        outTradeNo:data.orderNumber,
        tradeType:data.tradeType
    }).then(res=>{
        if(res.code == 1){
            console.log(res)
            bridgeData = {
                "appId": res.data.appId,
                "timeStamp": res.data.timeStamp,      
                "nonceStr": res.data.nonceStr,   
                "package": res.data.packageValue,
                "signType": res.data.signType,
                "paySign": res.data.paySign
            }
            if (typeof WeixinJSBridge == "undefined"){
                if( document.addEventListener ){
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                }else if (document.attachEvent){
                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
            }else{
                onBridgeReady(callback);
            }
        }else{
            Message({
                type:'error',
                message:res.msg
            })
        }
    })
}
// JSAPI方式微信内调起支付
function onBridgeReady(callback){
    WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
            "appId":bridgeData.appId,     //公众号名称，由商户传入     
            "timeStamp":bridgeData.timeStamp,  //时间戳，自1970年以来的秒数     
            "nonceStr":bridgeData.nonceStr, //随机串     
            "package":bridgeData.package,     
            "signType":bridgeData.signType,    //微信签名方式：     
            "paySign":bridgeData.paySign //微信签名 
        },function(res){
            console.log(res)
            if(res.err_msg == "get_brand_wcpay_request:ok" ){
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                Message({
                    type:'success',
                    message:'支付成功'
                })
                let url = window.location.href
                if(url.indexOf('myOrder') != -1){
                    if(sessionStorage.getItem("tabIndex") == 2){
                        router.push('/myOrder?flag=common')
                    }else{
                        window.location.reload()
                    }
                }else if(url.indexOf('trainOrderDetail') != -1){
                    router.push('/myOrder?flag=train')
                }else if(url.indexOf('index') != -1){
                    callback ? callback(true) : ''
                } else{
                    router.push('/myOrder')
                }
            }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
                callback ? callback(false) : ''
            }
    }); 
}

export default getPayOrder;
